// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".te-side-menu a[data-v-6d4087c4]{line-height:1.4286}@media(max-width:767.98px){.te-side-menu a[data-v-6d4087c4]{font-size:.75rem}}.te-side-menu a.te-nav-current[data-v-6d4087c4]{background:#ccc;font-weight:700}.te-side-menu a[data-v-6d4087c4]:hover{background:#ccc}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
